import IEO from "../../components/Olympiad/ClassOne/IEO";
import IGKO from "../../components/Olympiad/ClassOne/IGKO";
import IMO from "../../components/Olympiad/ClassOne/IMO";
import NCO from "../../components/Olympiad/ClassOne/NCO";
import NSO from "../../components/Olympiad/ClassOne/NSO";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/olympiad-classone/nso", title: "National Science Olympiad (NSO)", component: NSO },
    { url: "/olympiad-classone/imo", title: "International Mathematics Olympiad (IMO)", component: IMO },
    { url: "/olympiad-classone/nco", title: "National Cyber Olympiad (NCO)", component: NCO },
    { url: "/olympiad-classone/igko", title: "International General Knowledge Olympiad (IGKO)", component: IGKO },
    { url: "/olympiad-classone/ieo", title: "International English Olympiad (IEO)", component: IEO },
   // { url: "/olympiad-classone/iom", title: "International Olympiad of Mathematics (IOM)" },
];

export default topics;